<template>
    <div id="app" class="app">
        <el-container>
            <el-header v-if="showHeader">
                <Header :active_index="active_index" />
            </el-header>
            <el-main>
                <router-view></router-view>
            </el-main>
        </el-container>
    </div>
</template>
<script>
import Header from './components/Header.vue'
import axios from 'axios';
import config from './components/config.js';
export default {
    name: 'app',
    components: {
        Header
    },
    data() {
        return {
            showHeader: true,
            active_index: ''
        }
    },
    created() {
        this.checkLogin()
        if(this.$route.name == 'jianchaaction' || this.$route.name == 'action'){
            this.showHeader = false
        }
        else{
            this.showHeader = true
        }
        if(this.$route.name == 'duixianglists'){
            this.active_index = '1'
        }
    },
    methods: {
        checkLogin() {
            let url = config.base_url + '/yun_table/users/islogin';
            axios.get(url, {
                headers: {
                    "Authorization": localStorage.getItem('token')
                }
            }).then((response) => {
                let res = response.data;
                if(res.login){
                    console.log('login true');
                }else{
                    console.log('login false');
                    this.$router.push({
                        'path': '/login'
                    })
                }
            })
            
        }
    }
}
</script>
<style>
#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
    margin-left: 5%;
    margin-right: 5%;
}
</style>